import { Box, Button, Flex, Image, Text } from "@chakra-ui/react"
import React from "react"
import supportAgentIcon from "@/assest/ic_customer_service.svg"

// 右上角通知卡片容器（从右往左滑入，无遮罩、不阻塞云桌面操作）。
// 全屏模式下虚拟鼠标事件系统通过 id 标记识别 UI 元素。
const cardId = "full-screen-unvideo-element-tag"

interface AssistRequestDialogProps {
  isOpen: boolean
  onConfirm: () => void
  onCancel: () => void
  // 是否下移避让（已连接卡片出现时传 true，请求卡片让位到下方，避免堆叠）
  shifted?: boolean
}

// 管理员申请远程协助：右上角通知卡片，带售后客服图标，拒绝红色/同意绿色按钮
export const AssistRequestDialog: React.FC<AssistRequestDialogProps> = ({
  isOpen,
  onConfirm,
  onCancel,
  shifted = false,
}) => {
  return (
    <Flex
      id={cardId}
      direction="column"
      position="fixed"
      top={shifted ? "112px" : "16px"}
      right="16px"
      width="360px"
      backgroundColor="rgba(48, 49, 60, 1)"
      borderRadius="12px"
      boxShadow="0 8px 24px rgba(0, 0, 0, 0.35)"
      zIndex={9999}
      overflow="hidden"
      // 从右往左滑入
      animation="assist-card-slide-in 0.28s ease-out"
      sx={{
        "@keyframes assist-card-slide-in": {
          from: { transform: "translateX(110%)", opacity: "0" },
          to: { transform: "translateX(0)", opacity: "1" },
        },
      }}
      display={isOpen ? "flex" : "none"}
    >
      <Flex align="center" px="16px" py="14px">
        <Image id={cardId} src={supportAgentIcon} boxSize="22px" mr="10px" flexShrink={0} />
        <Text color="white" fontSize="14px" whiteSpace="pre-line">
          管理员申请远程协助您的云电脑，是否同意？
        </Text>
      </Flex>
      <Flex width="100%" height="42px" borderTop="1px solid rgba(255, 255, 255, 0.1)">
        <Button
          id={cardId}
          flex={1}
          height="100%"
          variant="ghost"
          borderRadius={0}
          colorScheme="whiteAlpha"
          color="rgba(255, 90, 90, 0.95)"
          onClick={onCancel}
        >
          拒绝
        </Button>
        <Box id={cardId} background="rgba(255, 255, 255, 0.1)" height="100%" width="1px" />
        <Button
          id={cardId}
          flex={1}
          height="100%"
          variant="ghost"
          borderRadius={0}
          colorScheme="whiteAlpha"
          color="rgba(80, 220, 120, 0.95)"
          onClick={onConfirm}
        >
          同意
        </Button>
      </Flex>
    </Flex>
  )
}

interface AssistConnectedDialogProps {
  isOpen: boolean
}

// 售后已连接：右上角通知卡片，带售后客服图标，3 秒自动消失（由父组件控制 isOpen）
export const AssistConnectedDialog: React.FC<AssistConnectedDialogProps> = ({
  isOpen,
}) => {
  return (
    <Flex
      id={cardId}
      align="center"
      position="fixed"
      top="16px"
      right="16px"
      width="360px"
      px="16px"
      py="14px"
      backgroundColor="rgba(48, 49, 60, 1)"
      borderRadius="12px"
      boxShadow="0 8px 24px rgba(0, 0, 0, 0.35)"
      zIndex={9999}
      overflow="hidden"
      animation="assist-card-slide-in 0.28s ease-out"
      sx={{
        "@keyframes assist-card-slide-in": {
          from: { transform: "translateX(110%)", opacity: "0" },
          to: { transform: "translateX(0)", opacity: "1" },
        },
      }}
      display={isOpen ? "flex" : "none"}
    >
      <Image id={cardId} src={supportAgentIcon} boxSize="22px" mr="10px" flexShrink={0} />
      <Text color="white" fontSize="14px">
        售后人员已连接到您的云电脑
      </Text>
    </Flex>
  )
}
